import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)
export const ROUTES_MAP = {
  INDEX: 'Index',
  MERCHANT: 'Merchant',
  VAS: 'PublicVAS',
  VAS_ADDRESS: 'PublicVAS__address',
  VAS_PRODUCTS: 'PublicVAS__products',
  VAS_PAYMENT: 'PublicVAS__payment'
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: ROUTES_MAP.INDEX,
    component: Index
  },
  {
    path: '/uikit',
    name: 'UIKIT',
    component: () => import(/* webpackChunkName: "UIKit" */ '../views/UIKit.vue')
  },
  {
    path: '/:merchantId',
    name: ROUTES_MAP.MERCHANT,
    component: () => import(/* webpackChunkName: "ListMerchantVasses" */ '../views/ListMerchantVasses.vue')
  },
  {
    path: '/:merchantId/public/:shopId/:vasId',
    name: ROUTES_MAP.VAS,
    component: () => import(/* webpackChunkName: "VASDetails" */ '../views/VASDetails.vue'),
    children: [
      {
        path: '',
        name: ROUTES_MAP.VAS_PRODUCTS,
        component: () => import(/* webpackChunkName: "VasCatalog" */ '../views/vas/VasCatalog.vue'),
      },

      {
        path: 'address',
        name: ROUTES_MAP.VAS_ADDRESS,
        component: () => import(/* webpackChunkName: "VasAddress" */ '../views/vas/VasAddress.vue'),
      },
      {
        path: 'payment',
        name: ROUTES_MAP.VAS_PAYMENT,
        component: () => import(/* webpackChunkName: "VasPayment" */ '../views/vas/VasPayment.vue'),
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
